// extracted by mini-css-extract-plugin
export var add = "_g-h";
export var bar = "_g-0";
export var brandFieldsContainer = "_g-m";
export var centered = "_g-7";
export var container = "_g-1";
export var date = "_g-g";
export var dateSpinner = "_g-j";
export var errorText = "_g-9";
export var fieldSelectionContainer = "_g-n";
export var flexOne = "_g-8";
export var icon = "_g-4";
export var iconButtonContent = "_g-6";
export var loading = "_g-2";
export var logo = "_g-5";
export var mainForm = "_g-l";
export var merchantPaidDateRange = "_g-f";
export var monospace = "_g-e";
export var section = "_g-a";
export var splitStatus = "_g-k";
export var tabOutlet = "_g-3";
export var table = "_g-b";
export var tableCell = "_g-d";
export var tableHeader = "_g-c";
export var trashIcon = "_g-i";